import api, { problemService, TicketCompanyService, TicketMetroService } from "./ApiService";
import { backendUrl } from "../../../../zabbix-shared/env";
import { ProblemStatus } from "../../../../zabbix-shared/interfaces/intefaces";
import { toast } from 'vue3-toastify';
import OnlineUserService from "../OnlineUserService";
import { ZabbixApiService } from "./zabbixApiService";
import { replacePlaceholders } from "../../../../zabbix-shared/utils/replacePlaceholders";
export class ZabbixActions {
    static async execute(options: any, problemZabbix: any) {
        let { name, eventid, clock, hostId, itemId, triggerId, zabbixId } = problemZabbix;

        this.prepareEditedMessages(options, problemZabbix);

        if (options.ticket) {
            const ticketResponse = await this.openTicket(zabbixId, options);
            
            const ticketCompanyData = await TicketCompanyService.open({
                ...options.ticketCompanyData,
                ...options.selectedProblem,
                ...problemZabbix,
                isMonitoring: options.isMonitoring
            });

            let problem = {
                company: {
                    id: options.companyId
                },
                eventid: Number(eventid),
                name: name,
                clock: clock,
                hostId: hostId,
                itemId: itemId,
                triggerId: triggerId,
                ticketId: ticketResponse.id,
                ticketTitle: options.ticketTitle,
                zabbix: { id: zabbixId },
                status: ProblemStatus.ACKNOWLEDGE,
                ticketOpenData: ticketCompanyData,
            };

            await problemService.create(problem);
        }

        if (options.acknowledged) {
            try {
                ZabbixApiService.acknowledgeProblem(eventid, options.ackMessage, zabbixId, options.companyId)
            } catch (error) {
                toast.error("Erro ao reconhecer problema no Zabbix");
            }
        }

        toast.success("Ações executadas com sucesso!", { autoClose: 1000 });
    }

    static async openTicket(zabbixId: string, options: any) {
        const body = {
            zabbixId,
            company: {
                id: options.companyId
            },
            title: options.ticketTitle || "Ticket sem título",
            subject: options.ticketTitle,
            description: options.ticketMessage,
            ticketType: options.ticketType
        };

        let response = null;
        try {
            response = await TicketMetroService.open(body);
        } catch (error) {
            toast.error("Erro ao abrir ticket");
        }

        return response.data;
    }

    static async prepareEditedMessages(options: any, problem: any) {
        const user = OnlineUserService.getUser();
        if (!user) return;

        const values = {
            "{{HOST}}": problem.hostName,
            "{{PROBLEM}}": problem.name,
            "{{TIME}}": problem.readableTime,
            "{{USER}}": user.name,
        };

        options.ackMessage = replacePlaceholders(options.ackMessage, values);
        options.ticketTitle = replacePlaceholders(options.ticketTitle, values);
        options.ticketMessage = replacePlaceholders(options.ticketMessage, values);
    }
}